/**
 * HTMLコンテンツから見出し（h2, h3）を抽出し、目次用のIDを付与する共通処理
 */

export interface ContentTocProps {
  level: number;
  id: string;
  text: string;
}

/**
 * Document から h2, h3 を抽出して目次用の情報を返す。
 * 各要素に id 属性を付与する（同一ドキュメントを書き換える）。
 */
function extractToc(doc: Document): ContentTocProps[] {
  const headingElements = doc.querySelectorAll("h2, h3");
  return Array.from(headingElements).map((element, index) => {
    const text = element.textContent?.trim() || `toc-item-${index}`;
    const level = (parseInt(element.tagName.charAt(1), 10) - 1) || 1;
    element.id = text;
    return {
      level,
      id: text,
      text,
    };
  });
}

/**
 * HTML文字列をパースし、見出し一覧とID付与済みの本文HTMLを返す。
 * 目次表示やアンカーリンク用に利用する。
 */
export function parseContentWithHeadings(showToc: boolean, htmlContent: string): {
  anchors: ContentTocProps[];
  contentWithHeadingIds: string;
} {
  if (!showToc) {
    return {
      anchors: [],
      contentWithHeadingIds: htmlContent,
    };
  }
  const parser = new DOMParser();
  const parsedContent = parser.parseFromString(htmlContent, "text/html");
  const anchors = extractToc(parsedContent);
  return {
    anchors,
    contentWithHeadingIds: parsedContent.body.innerHTML,
  };
}
